module.exports = __webpack_public_path__ + "static/media/contrato.055aac76.pdf";